function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Header-/-BE_avatar_wit_26px",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.0958525346,0.0299539171 L0.0958525346,0.0299539171 L0.0958525346,24.6341014 C0.0718894009,24.9695853 0.0539170507,25.3110599 0.0539170507,25.6585253 C0.0539170507,25.6824885 0.0539170507,25.7004608 0.0539170507,25.724424 L0.0539170507,25.7603687 L0.0958525346,25.7603687 L0.0958525346,25.9880184 L0.287557604,25.9880184 L0.287557604,26 L25.7124424,26 L25.7124424,25.9880184 L25.9520737,25.9880184 L25.9520737,0.0299539171 L25.9520737,0.0299539171 L0.0958525346,0.0299539171 Z M0.569124424,0.50921659 L10.6815668,0.50921659 C8.23133641,1.45576037 6.48202765,3.84009217 6.48202765,6.62580645 C6.48202765,9.53133641 8.38110599,11.9995392 11.0110599,12.8562212 C6.01474654,13.6290323 1.95898618,17.2654378 0.569124424,22.0341014 L0.569124424,0.50921659 L0.569124424,0.50921659 Z M0.569124424,25.5087558 L0.569124424,24.6460829 C1.0843318,18.2419355 6.4640553,13.1797235 13,13.1797235 C19.8294931,13.1797235 25.3949309,18.697235 25.4728111,25.5087558 L0.569124424,25.5087558 Z M6.96129032,6.62580645 C6.96129032,3.27096774 9.68709677,0.54516129 13.0419355,0.54516129 C16.3967742,0.54516129 19.1225806,3.27096774 19.1225806,6.62580645 C19.1225806,9.98064516 16.3967742,12.7064516 13.0419355,12.7064516 C9.68709677,12.7064516 6.96129032,9.98064516 6.96129032,6.62580645 Z M15.0428571,12.8682028 C17.6847926,12.0175115 19.5958525,9.54331797 19.5958525,6.62580645 C19.5958525,3.84009217 17.8525346,1.46175115 15.3963134,0.50921659 L25.4668203,0.50921659 L25.4668203,22.1898618 C24.1308756,17.3672811 20.0631336,13.6709677 15.0428571,12.8682028 Z"
})));
function SvgAvatarWit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Header / BE_avatar_wit_26px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarWit);
export default __webpack_public_path__ + "static/media/Avatar_wit.e319d21f4559c864940170911d1cdcb0.svg";
export { ForwardRef as ReactComponent };